import React, { useEffect, useState } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  TextField,
  Button,
  Select,
  MenuItem,
} from '@mui/material';
import { SelectChangeEvent } from '@mui/material/Select';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Infra } from '@getvim/vim-connect';
import useLocalStorage from 'react-localstorage-hook';
import { isEmpty } from 'lodash-es';
import { VimEhrDisplayReLoginScreen } from '../../mocks/login-events';
import { FlexBox } from '../common/FlexBox';
import { MonacoEditor } from '../monaco-editor';
import { Types, handlePublish } from './utils';

export const VimEhrDisplayReLoginScreenTab = () => {
  const [payload, setPayload] = useState<Types.VimEhrDisplayReLoginScreenPayload>();
  const [predefinedPayload, setPredefinedPayload] = useState<string>('');
  const [lastUsedPayload, setLastUsedPayload] = useLocalStorage(
    'lastVimEhrDisplayReLoginScreenPayload',
    '',
  );

  useEffect(() => {
    handlePredefinedPayloadChange({ target: { value: lastUsedPayload } } as SelectChangeEvent);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePredefinedPayloadChange = ({ target: { value } }: SelectChangeEvent) => {
    setPredefinedPayload(value);
    setLastUsedPayload(value);
    setPayload(VimEhrDisplayReLoginScreen.predefinedPayloads[value]);
  };

  return (
    <Accordion id="vimEhrDisplayReLoginScreenTab">
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>VimEhrDisplayReLoginScreen</Typography>
        <Select
          id="select-vim-ehr-display-re-login-screen"
          displayEmpty
          value={predefinedPayload}
          size="small"
          onChange={handlePredefinedPayloadChange}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <MenuItem value="">Choose</MenuItem>
          {Object.keys(VimEhrDisplayReLoginScreen.predefinedPayloads).map((value, index) => (
            <MenuItem
              id={`select-vim-ehr-display-re-login-screen-${index}`}
              value={value}
              key={value}
            >
              {value}
            </MenuItem>
          ))}
        </Select>

        <Button
          id="publish-vim-ehr-display-re-login-screen"
          disabled={isEmpty(predefinedPayload)}
          fullWidth
          onClick={(e) => {
            e.stopPropagation();
            handlePublish(payload, Infra.Common.Types.LoginEvent.DISPLAY_RE_LOGIN_SCREEN);
          }}
          variant="contained"
        >
          Publish
        </Button>
      </AccordionSummary>
      <AccordionDetails>
        <MonacoEditor onChange={setPayload} height="10rem" value={payload} />

        <FlexBox>
          <TextField
            id="vimEhrDisplayReLoginScreenPayload"
            variant="outlined"
            size="small"
            value={JSON.stringify(payload)}
            sx={{ display: 'none' }}
          />
        </FlexBox>
      </AccordionDetails>
    </Accordion>
  );
};
